// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2eYtU","title":"styles_title__Qp9BH"};